export const colorConstants = {
    White: '#ffffff',
    WhiteSmoke: '#F6F6F9',
    Toolbox: '#7676C0',
    LightToolbox: '#a7a2d7',
    LightSteelBlue: '#ACBCE4',
    EerieBlack: '#181f1C',
    PurpleTaupe: '#44344F',
    RedOrange: '#FF4500'
}